import { isUuid } from '../reactions/layer-list-ids.js';

export const INVENTORY_FLAG_SCHEMA = 'janus.inventory.flag.v1';
const row = (value: unknown): Record<string, unknown> | null => value !== null && typeof value === 'object' && !Array.isArray(value)
  ? value as Record<string, unknown> : null;
const bit = (value: unknown): boolean => value === 0 || value === 1;

/** Runtime admission of the final flag envelope, including mutations made during hidden preparation.
 * The hidden planner owns its plan's contract; this boundary owns the enclosing flag values. */
export function inventoryFlagValueRefusal(value: unknown): string | null {
  const command = row(value);
  if (!command || command.schema !== INVENTORY_FLAG_SCHEMA) return 'inventory-flag:invalid-schema';
  if (Object.keys(command).some(key => !['schema', 'operation_id', 'encounter_id', 'inventory_id', 'kind', 'actor_id', 'before', 'after', 'hidden_plan'].includes(key)))
    return 'inventory-flag:invalid-columns';
  if (command.kind !== 'wares' && command.kind !== 'hidden') return 'inventory-flag:invalid-kind';
  if (!isUuid(command.inventory_id) || !isUuid(command.operation_id)
    || (command.encounter_id !== '' && !isUuid(command.encounter_id))) return 'inventory-flag:invalid-identity';
  if (command.kind === 'wares' && !isUuid(command.actor_id)) return 'inventory-flag:invalid-actor';
  const before = row(command.before), after = row(command.after);
  if (!before || !after || Object.keys(before).some(key => key !== 'value' && key !== 'possess_id')
    || Object.keys(after).some(key => key !== 'value') || !isUuid(before.possess_id)
    || !bit(before.value) || !bit(after.value)) return 'inventory-flag:invalid-before-after';
  if (before.value === after.value) return 'inventory-flag:no-change';
  return null;
}
